import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const EXHIBITION_HOME_URL = 'https://www.artefactsofthefuture.ethz.ch/';
export const IMPRINT_PRIVACY_URL = 'https://www.artefactsofthefuture.ethz.ch/privacy-imprint';

export default function OverviewFooterLinks() {
  const { t } = useLanguage();

  return (
    <div className="overview-footer-links">
      <span className="overview-footer-links__credit">{t('app.projectOfEthZurich')}</span>
      <span className="overview-footer-links__sep" aria-hidden="true">
        ·
      </span>
      <a
        className="overview-imprint-link"
        href={EXHIBITION_HOME_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('app.moreInformation')}
      </a>
      <span className="overview-footer-links__sep" aria-hidden="true">
        ·
      </span>
      <a
        className="overview-imprint-link"
        href={IMPRINT_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('app.imprintPrivacy')}
      </a>
    </div>
  );
}
